import AssetPack from "../../../libs/phaserextension/assets/AssetPack";
import { SafeUtils } from "../../PhaserExtension";

export default class SchoolAssetPack extends AssetPack
{
    constructor()
    {
        super();
        this.localizedAudio = null;
    }

    dispose()
    {
        super.dispose();
        this.localizedAudio = null;
    }
}

/**
 * Constructs an AssetPack from the information in the data.
 * @param {*} assetPackData
 */
export function getAssetPack(assetPackData)
{
    let assetPack = new SchoolAssetPack();

    // Get each of the asset lists from the data. If a list doesn't
    // then fallback to an empty array.
    assetPack.images = SafeUtils.getElse([assetPackData, "images"], []);
    assetPack.json = SafeUtils.getElse([assetPackData, "json"], []);
    assetPack.flump = SafeUtils.getElse([assetPackData, "flump"], []);
    assetPack.audio = SafeUtils.getElse([assetPackData, "audio"], []);
    assetPack.localizedAudio = SafeUtils.getElse([assetPackData, "localizedAudio"], {english:[], spanish:[]});
    //TODO - Add additional asset groups to support more assets types Phaser can load.

    return assetPack;
}
